import script from "./PageTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=b2dc7446&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2dc7446"]])

export default __exports__